import React, { useLayoutEffect } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

const CRMDonut = () => {
    useLayoutEffect(() => {
        // Create root element
        const root = am5.Root.new("chartdiv");

        // Set theme
        root.setThemes([am5themes_Animated.new(root)]);

        // Create chart
        const chart = root.container.children.push(
            am5percent.PieChart.new(root, {
                layout: root.verticalLayout,
                innerRadius: am5.percent(60),
            })
        );

        // Create series
        const series = chart.series.push(
            am5percent.PieSeries.new(root, {
                valueField: "value",
                categoryField: "category",
                alignLabels: false,
            })
        );

        // Hide labels/ticks if you want a clean donut
        // series.labels.template.set("visible", false);
        // series.ticks.template.set("visible", false);

        // Or show circular labels
        series.labels.template.setAll({
            textType: "circular",
            radius: 10,
            fontSize: 12,
        });

        // ✅ Define data with specific colors
        const data = [
            { value: 48, category: "Converted", color: am5.color(0x22c55e) }, // green
            { value: 25, category: "In Progress", color: am5.color(0x3b82f6) }, // blue
            { value: 17, category: "Pending", color: am5.color(0xfacc15) }, // yellow
            { value: 10, category: "Not Interested", color: am5.color(0xef4444) }, // red
        ];

        // ⚙️ Assign data *and* explicitly set color per slice
        series.data.setAll(data);
        series.slices.each((slice, i) => {
            slice.setAll({
                fill: data[i].color,
                stroke: data[i].color,
            });
        });

        // Create legend
        const legend = chart.children.push(
            am5.Legend.new(root, {
                centerX: am5.percent(50),
                x: am5.percent(50),
                marginTop: 20,
            })
        );

        legend.data.setAll(series.dataItems);

        // Animate
        series.appear(1000, 100);

        // Cleanup on unmount
        return () => root.dispose();
    }, []);

    return (
        <div className="bg-white p-4 rounded-xl shadow-md">
            <h3 className="dashboard-title">
                CRM Leads Overview
            </h3>
            <div id="chartdiv" className="w-full h-[400px]"></div>
        </div>
    );
};

export default CRMDonut;
